var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.500122 15.5C0.500122 16.05 0.950122 16.5 1.50012 16.5H6.50012V14.5H1.50012C0.950122 14.5 0.500122 14.95 0.500122 15.5ZM0.500122 3.5C0.500122 4.05 0.950122 4.5 1.50012 4.5H10.5001V2.5H1.50012C0.950122 2.5 0.500122 2.95 0.500122 3.5ZM10.5001 17.5V16.5H17.5001C18.0501 16.5 18.5001 16.05 18.5001 15.5C18.5001 14.95 18.0501 14.5 17.5001 14.5H10.5001V13.5C10.5001 12.95 10.0501 12.5 9.50012 12.5C8.95012 12.5 8.50012 12.95 8.50012 13.5V17.5C8.50012 18.05 8.95012 18.5 9.50012 18.5C10.0501 18.5 10.5001 18.05 10.5001 17.5ZM4.50012 7.5V8.5H1.50012C0.950122 8.5 0.500122 8.95 0.500122 9.5C0.500122 10.05 0.950122 10.5 1.50012 10.5H4.50012V11.5C4.50012 12.05 4.95012 12.5 5.50012 12.5C6.05012 12.5 6.50012 12.05 6.50012 11.5V7.5C6.50012 6.95 6.05012 6.5 5.50012 6.5C4.95012 6.5 4.50012 6.95 4.50012 7.5ZM18.5001 9.5C18.5001 8.95 18.0501 8.5 17.5001 8.5H8.50012V10.5H17.5001C18.0501 10.5 18.5001 10.05 18.5001 9.5ZM13.5001 6.5C14.0501 6.5 14.5001 6.05 14.5001 5.5V4.5H17.5001C18.0501 4.5 18.5001 4.05 18.5001 3.5C18.5001 2.95 18.0501 2.5 17.5001 2.5H14.5001V1.5C14.5001 0.95 14.0501 0.5 13.5001 0.5C12.9501 0.5 12.5001 0.95 12.5001 1.5V5.5C12.5001 6.05 12.9501 6.5 13.5001 6.5Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFilterIcon);
export default __webpack_public_path__ + "static/media/ic_filter_icon.cd9f6734a63d7bff3e23484797c344a0.svg";
export { ForwardRef as ReactComponent };